import StudentListSection from "../components/student-list-section";
// import { useEffect } from "react";
// import { useDispatch } from "react-redux";
// import { resetAllState } from "@/store/slices/studentSlice";

function StudentHome() {
  // const dispatch = useDispatch();

  // // Reset student slice state when component unmounts
  // useEffect(() => {
  //   // Cleanup function will run when component unmounts
  //   return () => {
  //     dispatch(resetAllState());
  //   };
  // }, [dispatch]);

  return (
    <div className="h-full flex flex-col gap-6">
      {/* Students List - Takes remaining height */}
      <div className="h-full">
        <StudentListSection />
      </div>
    </div>
  );
}

export default StudentHome;
